import _regeneratorRuntime from "/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/regenerator";
import _classCallCheck from "/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createClass";
import _possibleConstructorReturn from "/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/getPrototypeOf";
import _inherits from "/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/inherits";
import _assertThisInitialized from "/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/assertThisInitialized";

/**
 * @file Created on Fri Jan 25 2019
 * @author LZe
 */
var __decorate = this && this.__decorate || function (decorators, target, key, desc) {
  var c = arguments.length,
      r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc,
      d;
  if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);else for (var i = decorators.length - 1; i >= 0; i--) {
    if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
  }
  return c > 3 && r && Object.defineProperty(target, key, r), r;
};

var __metadata = this && this.__metadata || function (k, v) {
  if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};

var __awaiter = this && this.__awaiter || function (thisArg, _arguments, P, generator) {
  function adopt(value) {
    return value instanceof P ? value : new P(function (resolve) {
      resolve(value);
    });
  }

  return new (P || (P = Promise))(function (resolve, reject) {
    function fulfilled(value) {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    }

    function rejected(value) {
      try {
        step(generator["throw"](value));
      } catch (e) {
        reject(e);
      }
    }

    function step(result) {
      result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
    }

    step((generator = generator.apply(thisArg, _arguments || [])).next());
  });
};

import { NotificationState } from '@logio/common-be-fe';
import { action, observable, runInAction } from 'mobx';
import { CONSTANTS } from '../../../constants';
import { Polling } from '../../../shared/polling/Polling';
import { NotificationLayer } from '../../transportLayers/notification/NotificationLayer';
import { BaseStore } from '../BaseStore';
import { StoreName } from '../StoreName';
export var NotificationStore =
/*#__PURE__*/
function (_BaseStore) {
  _inherits(NotificationStore, _BaseStore);

  function NotificationStore() {
    var _this;

    _classCallCheck(this, NotificationStore);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(NotificationStore).apply(this, arguments));
    /** Store name */

    _this.name = StoreName.Notification;
    _this.notificationLayer = new NotificationLayer();
    _this.polling = new Polling(CONSTANTS.NOTIFICATIONS_POLLING_INTERVAL_IN_MS);
    _this.notifications = new Map();
    _this.newNotifications = new Map();

    _this.onPromoPollResponse = function (error, data) {
      if (data) {
        runInAction(function () {
          _this.newNotifications.clear();

          data.notifications.forEach(function (notification) {
            _this.newNotifications.set(notification.id, notification);
          });
          _this.notificationsTotalCount = data.totalCount;
        });
      }
    };

    _this.onPricingPollResponse = function (error, notifications) {
      if (notifications) {
        runInAction(function () {
          _this.newNotifications.clear();

          notifications.forEach(function (notification) {
            _this.newNotifications.set(notification.id, notification);
          });
          _this.notificationsTotalCount = _this.newNotifications.size;
        });
      }
    };

    _this.remove = function (ids) {
      return __awaiter(_assertThisInitialized(_assertThisInitialized(_this)), void 0, void 0,
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee() {
        var _this2 = this;

        var result;
        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.next = 2;
                return this.notificationLayer.delete(ids);

              case 2:
                result = _context.sent;

                if (result === true) {
                  runInAction(function () {
                    return _this2.notificationsTotalCount = _this2.notificationsTotalCount - ids.length;
                  });
                  ids.forEach(function (id) {
                    return runInAction(function () {
                      _this2.notifications.delete(id);

                      _this2.newNotifications.delete(id);
                    });
                  });
                }

              case 4:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this);
      }));
    };

    _this.markAsRead = function (ids) {
      return __awaiter(_assertThisInitialized(_assertThisInitialized(_this)), void 0, void 0,
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee2() {
        var _this3 = this;

        var result;
        return _regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                _context2.next = 2;
                return this.notificationLayer.markAsRead(ids);

              case 2:
                result = _context2.sent;

                if (result === true) {
                  ids.forEach(function (id) {
                    return runInAction(function () {
                      var oldNotification = _this3.notifications.get(id);

                      _this3.notifications.set(id, oldNotification.copy('state', NotificationState.read));
                    });
                  });
                }

              case 4:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, this);
      }));
    };

    return _this;
  }

  _createClass(NotificationStore, [{
    key: "startPolling",
    value: function startPolling() {
      var _this4 = this;

      CONSTANTS.APP.NAME === 'promo' ? this.polling.startPolling(function () {
        return _this4.notificationLayer.getNewNotifications(10);
      }, this.onPromoPollResponse) : this.polling.startPolling(function () {
        return _this4.notificationLayer.findAll();
      }, this.onPricingPollResponse);
    }
  }, {
    key: "stopPolling",
    value: function stopPolling() {
      this.polling.stopPolling();
    }
    /**
     * Get all notifications
     * @returns Promise<Notification[]>
     */

  }, {
    key: "getAll",
    value: function getAll() {
      var _this5 = this;

      return this.notificationLayer.findAll().then(function (notifications) {
        if (notifications) {
          runInAction(function () {
            _this5.notifications.clear();

            notifications.forEach(function (notification) {
              _this5.notifications.set(notification.id, notification);
            });
          });
        }

        return notifications;
      });
    }
  }]);

  return NotificationStore;
}(BaseStore);

__decorate([observable, __metadata("design:type", Map)], NotificationStore.prototype, "notifications", void 0);

__decorate([observable, __metadata("design:type", Map)], NotificationStore.prototype, "newNotifications", void 0);

__decorate([observable, __metadata("design:type", Number)], NotificationStore.prototype, "notificationsTotalCount", void 0);

__decorate([action, __metadata("design:type", Object)], NotificationStore.prototype, "onPromoPollResponse", void 0);

__decorate([action, __metadata("design:type", Object)], NotificationStore.prototype, "onPricingPollResponse", void 0);

__decorate([action, __metadata("design:type", Object)], NotificationStore.prototype, "remove", void 0);

__decorate([action, __metadata("design:type", Object)], NotificationStore.prototype, "markAsRead", void 0);

__decorate([action.bound, __metadata("design:type", Function), __metadata("design:paramtypes", []), __metadata("design:returntype", Promise)], NotificationStore.prototype, "getAll", null);